import { Amplify } from 'aws-amplify';
import {
    signIn as amplifySignIn,
    signUp as amplifySignUp,
    signOut as amplifySignOut,
    confirmSignUp as amplifyConfirmSignUp,
    getCurrentUser as amplifyGetCurrentUser
} from '@aws-amplify/auth';

// Initialize Amplify with Cognito configuration
Amplify.configure({
    Auth: {
        Cognito: {
            region: 'us-east-2',  // Update with your region
            userPoolId: 'us-east-2_kPZS7CGon',  // Update with your User Pool ID
            userPoolClientId: '2u03gv989cc0mq40hh9tks595m',  // Update with your Client ID
        }
    }
});

export const signUp = async (email, password) => {
    try {
        const { user } = await amplifySignUp({
            username: email.toLowerCase(),
            password,
            attributes: {
                email: email.toLowerCase()
            }
        });
        return user;
    } catch (error) {
        throw error;
    }
};

export const confirmSignUp = async (email, code) => {
    try {
        await amplifyConfirmSignUp({
            username: email.toLowerCase(),
            confirmationCode: code
        });
    } catch (error) {
        throw error;
    }
};

export const signIn = async (email, password) => {
    try {
        const user = await amplifySignIn({
            username: email.toLowerCase(),
            password
        });
        return user;
    } catch (error) {
        throw error;
    }
};

export const signOut = async () => {
    try {
        await amplifySignOut();
    } catch (error) {
        throw error;
    }
};

export const getCurrentUser = async () => {
    try {
        const user = await amplifyGetCurrentUser();
        return user;
    } catch (error) {
        return null;
    }
};